import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || !isHome
            ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-3 group"
            >
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-building-line text-2xl text-primary-500"></i>
              </div>
              <span className={`font-heading text-xl font-bold transition-colors ${
                isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
              }`}>
                琉璃神社
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/'
                    ? 'text-primary-500'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white/80 hover:text-white'
                }`}
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'text-primary-500'
                      : isScrolled || !isHome
                        ? 'text-foreground-700 hover:text-primary-500'
                        : 'text-white/80 hover:text-white'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/about'
                    ? 'text-primary-500'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white/80 hover:text-white'
                }`}
              >
                关于我们
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <button className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap">
                <i className="ri-search-line text-sm"></i>
              </button>
              <Link
                to="/category/membership"
                className="px-5 py-2 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                加入会员
              </Link>
            </div>

            <button
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
                isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
              }`}
              onClick={() => setIsMobileOpen(!isMobileOpen)}
            >
              <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        <div
          className={`md:hidden transition-all duration-300 overflow-hidden ${
            isMobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="bg-background-50 border-t border-background-200 px-4 py-4 space-y-2">
            <Link to="/" className="block px-4 py-3 rounded-lg text-foreground-700 hover:bg-background-100 font-medium whitespace-nowrap">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-4 py-3 rounded-lg text-foreground-700 hover:bg-background-100 font-medium whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-4 py-3 rounded-lg text-foreground-700 hover:bg-background-100 font-medium whitespace-nowrap">
              关于我们
            </Link>
            <Link
              to="/category/membership"
              className="block px-4 py-3 rounded-full bg-accent-500 text-background-50 text-center font-semibold whitespace-nowrap"
            >
              加入会员
            </Link>
          </div>
        </div>
      </nav>

      <div className="h-16"></div>
    </>
  );
}